import { LoadingIndicator } from '@components';
import { plans } from '@utils';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { CardHome } from '../../common/components/CardsHome';
import { getRentabilidade, getSaudeFinanceira } from '../../store/plan/thunks';

export const HomePage = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const loadingUser = useSelector((state) => state.user.isLoading);
  const corteExtrato = useSelector(
    (state) => state.configs.dataCorte.data.corteExtrato
  );
  const rentabilidadeDone = useSelector(
    (state) => state.plan.rentabilidade.done
  );
  const saudeFinanceiraDone = useSelector(
    (state) => state.plan.saudeFinanceira.done
  );
  const patrocinadora = useSelector((state) => state.plan.patrocinadora.data);
  const {
    grafico_rendimento: showRendimentos,
    tabela_contribuicao: showTabelaContribuicao,
    saude_financeira: showSaudeFinanceira,
  } = useSelector((state) => state.configs.telasDisponiveis.data);

  const [hasRequestedRentabilidade, setHasRequestedRentabilidade] =
    useState(false);
  const [hasRequestedSaudeFinanceira, setHasRequestedSaudeFinanceira] =
    useState(false);

  const isReady =
    !loadingUser &&
    !!user.data.matricula &&
    !!user.data.plano &&
    !!user.dadosPessoais.nome;

  const corteExtratoValido =
    Array.isArray(corteExtrato) && corteExtrato.length === 2;

  useEffect(() => {
    if (
      isReady &&
      corteExtratoValido &&
      (showRendimentos || showTabelaContribuicao) &&
      !rentabilidadeDone &&
      !hasRequestedRentabilidade
    ) {
      dispatch(getRentabilidade());
      setHasRequestedRentabilidade(true);
    }
  }, [
    dispatch,
    isReady,
    corteExtratoValido,
    showRendimentos,
    showTabelaContribuicao,
    rentabilidadeDone,
    hasRequestedRentabilidade,
  ]);

  useEffect(() => {
    if (
      isReady &&
      corteExtratoValido &&
      showSaudeFinanceira &&
      !saudeFinanceiraDone &&
      !hasRequestedSaudeFinanceira
    ) {
      dispatch(getSaudeFinanceira());
      setHasRequestedSaudeFinanceira(true);
    }
  }, [
    dispatch,
    isReady,
    corteExtratoValido,
    showSaudeFinanceira,
    saudeFinanceiraDone,
    hasRequestedSaudeFinanceira,
  ]);

  return isReady ? (
    <>
      <Helmet>
        <title>Forluz - Home</title>
      </Helmet>
      <div className="d-none d-md-block mb-5 mt-0">
        <span className="text-muted ts-24 ">
          <strong>Olá, {user.dadosPessoais.nome}.&nbsp;</strong>O que você
          precisa hoje?
        </span>
        <br />
        <span className="text-muted ts-20 ">
          <strong>Plano {plans[user.data.plano]}&nbsp;</strong>
          {patrocinadora}
        </span>
      </div>
      <div className="d-block d-md-none text-muted ts-20 mb-5">
        <span className="text-muted ts-24 ">
          <strong>Olá, {user.dadosPessoais.nome}.&nbsp;</strong>O que você
          precisa hoje?
        </span>
        <br />
        <span className="text-muted ts-20 ">
          <strong>Plano {plans[user.data.plano]}&nbsp;</strong>
          {patrocinadora}
        </span>
      </div>
      <CardHome isHomePage />
    </>
  ) : (
    <LoadingIndicator />
  );
};
